document.addEventListener("DOMContentLoaded", function() {
    if (window.innerWidth > 768) {
        //console.log("Desktop detected, running the script");

        function attemptFind(selector, callback, attempts = 200, delay = 100) {
            let attemptCount = 0;
            //console.log(`Looking for: ${selector}`);
            const interval = setInterval(() => {
                const element = document.querySelector(selector);
                if (element) {
                    //console.log(`Found element: ${selector}`);
                    clearInterval(interval);
                    callback(element);
                } else if (++attemptCount >= attempts) {
                    //console.log(`Failed to find: ${selector} after ${attempts} attempts`);
                    clearInterval(interval); // Stop after max attempts
                } else {
                    //console.log(`Attempt ${attemptCount} for: ${selector}`);
                }
            }, delay);
        }

        attemptFind(".cky-consent-container.cky-banner-bottom", () => {
            //console.log("Found .cky-consent-container.cky-banner-bottom, now trying to find and style other elements.");

            attemptFind("#tidio-chat-iframe", (iframe) => {
                //console.log("Found #tidio-chat-iframe, setting interval to apply style.");

                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                if (iframeDocument) {
                    attemptFindInIframe(iframeDocument, ".frame-content .widget-position-right #button", (button) => {
                        //console.log("Applying bottom: 80px !important to #button inside iframe");
                        button.style.setProperty("bottom", "80px", "important"); // Add bottom without overwriting other styles
                    });
                }

                setInterval(() => {
                    //console.log("Applying height: 747px !important to #tidio-chat-iframe");
                    iframe.style.setProperty("height", "747px", "important"); // Add height without overwriting other styles
                }, 500);
            });
        });

        function attemptFindInIframe(iframeDoc, selector, callback, attempts = 200, delay = 100) {
            let attemptCount = 0;
            //console.log(`Looking for: ${selector} inside iframe`);
            const interval = setInterval(() => {
                const element = iframeDoc.querySelector(selector);
                if (element) {
                    //console.log(`Found element: ${selector} inside iframe`);
                    clearInterval(interval);
                    callback(element);
                } else if (++attemptCount >= attempts) {
                    //console.log(`Failed to find: ${selector} inside iframe after ${attempts} attempts`);
                    clearInterval(interval); // Stop after max attempts
                } else {
                    //console.log(`Attempt ${attemptCount} for: ${selector} inside iframe`);
                }
            }, delay);
        }
    } else {
        //console.log("Mobile or tablet detected, skipping the script");
    }
});